import styled from 'styled-components'
import { Module } from '../../boxes/module'

const MessageContent = styled(Module)`
  width: 100%;
  white-space: pre-wrap;
`

export default MessageContent
